
// Customer fields
CF.ready(function() {
    var formId = 'QrtdV8';
    var $form = document.querySelector('form[data-cf-form="' + formId + '"]');
    const focus_inputs = $form ? $form.querySelectorAll('.on-focus-label') : null;
    const message_email_taken = 'This email address was already used to create an account. Please sign in with this email address to continue.';
    const message_phone_taken = 'This mobile number was already used to create an account.';


    if(focus_inputs) {
        focus_inputs.forEach(field => {
            const input = field.querySelector('input');
            const label = field.querySelector('label');
            const input_name = input.dataset.cfColumnKey;

            /*
            * Add attributes to inputs
            */
            if(input_name === 'first_name' || input_name === 'last_name') {
                setAttribute(input, 'maxlength', 24);
            } else if(input_name === 'phone') {
                setAttribute(input, 'maxlength', 16);
            } else if(input_name === 'email') {
                setAttribute(input, 'pattern', `^\\w+([\\.\\-\\+]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$`);
                input.required = true;
                input.type = 'email';
            }


            /*
            * Label animation
            */
            input.addEventListener('focus', function() {
                label.classList.add('on-focus');
                this.parentNode.classList.add('on-focus-active');
              
                if(document.querySelector('#form_general_error')) {
                  document.querySelector('#form_general_error').innerHTML = '';
                }
            })
            input.addEventListener('blur', function() {
                if(this.name === 'phone') {
                    if(this.value.trim() === "+63" || this.value.length <= 0) {
                        label.classList.remove('on-focus');
                        this.parentNode.classList.remove('on-focus-active');
                    }
                }else {
                    if(this.value.length <= 0) {
                        label.classList.remove('on-focus');
                        this.parentNode.classList.remove('on-focus-active');
                    }
                }
            })
            if(input.value.length > 0) {
              upLabel(label)
            }else {
              downLabel(label)
            }
        })
    }

    if($form) {
      /*
      * Edit info page
      */
      if(CF.customer.isLoggedIn && window.location.search === '?view=edit') {
        if($form.querySelector('input[data-accept-policy]')) {
          $form.querySelector('input[data-accept-policy]').removeAttribute('required');
        }
        const btn = $form.querySelector('.cf-submit-form');
        const error_message = document.querySelector('#form_general_error');
  
        btn.disabled = true;
  
        $form.addEventListener('cf:form_submitted', function(event) {
          window.stop();
          
          if(btn) {
            btn.innerHTML = '<div><span class="updated-check-icon">✓</span> SAVED</div>';
            btn.disabled = true;
          }
          
        });

        $form.addEventListener('cf:field_changed', function(event) {
          var customer_data = CF.customer.data;
          var columnKey = event.detail.columnKey;
          var currentField = event.target;
          var currentValue = customer_data[columnKey]
          var checkIcon = $form.querySelector('.updated-check-icon');
          var columns = CF.customer.columns
          var boolean_changes = [];
    
          columns.forEach(column => {
            var field = document.querySelector(`input[data-cf-column-key="${column.key}"]`)
            if(field) {
              if(column.key === 'accepts_marketing') {
                boolean_changes.push(field.checked === customer_data[column.key])
              }else if(column.key === 'phone') {
                boolean_changes.push(field.value.trim().replace(/\s/g, '') === customer_data[column.key])
              }else {
                boolean_changes.push(field.value === customer_data[column.key])
              }
            }
          })
          
          if(error_message) error_message.remove();
          
          if(checkIcon) {
            btn.textContent = 'Save Update';
          }
          
          if(boolean_changes.includes(false)) {
            btn.disabled = false;
          }else {
            btn.disabled = true;
          }
        })

        const bday_selects = $form.querySelectorAll('select[placeholder="Month"], select[placeholder="Day"], select[placeholder="Year"]')

        if(bday_selects) {
          bday_selects.forEach(select => {
            select.addEventListener('change', function() {
              let old_bdate = new Date(CF.customer.data.birthdate).getTime();
              const field_name = this.getAttribute('placeholder').toLowerCase();
              let bday_template = '{{year}}-{{month}}-{{day}}'
              
              bday_selects.forEach(function(date) {
                console.log(date.getAttribute('placeholder'))
                switch(date.getAttribute('placeholder')) {
                  case 'Month':
                    bday_template = bday_template.replace(/{{month}}/g, date.value.length === 1 ? `0${date.value}` : date.value);
                    break;
                  case 'Year':
                    bday_template = bday_template.replace(/{{year}}/g, date.value.length === 1 ? `0${date.value}` : date.value);
                    break;
                  case 'Day':
                    bday_template = bday_template.replace(/{{day}}/g, date.value.length === 1 ? `0${date.value}` : date.value);
                    break;
                }
              })
              let new_date = new Date(bday_template).getTime();
              
              if(old_bdate !== new_date) {
                btn.disabled = false;
              }else {
                btn.disabled = true;
              }
            })
          })
        }
      }

        /*
        * Add custom error message
        */
        $form.addEventListener('cf:form_submission_failed', function(event) {
            const errors = event.detail.errors;

            if(errors) {
                const error_names = Object.keys(errors);

                let error_elements = '';

                error_names.forEach(error => {
                    const error_message = errors[error].length > 0 ? errors[error][0] : null;
                    const message = error === 'email' ? message_email_taken : error === 'phone' ? message_phone_taken : error_message;

                    error_elements += compileErrorMessage(message);
                })

                if(error_elements.length > 0) renderErrorMessage(error_elements);
            }
        });


        /*
        * Add custom field validations
        */
        var validateEmail = {
            comparator: function isValid(value) {
                var invalidCharacters = /[ `!#$%^&*()\=\[\]{};':"\\|,<>\/?~\+]/.test(value);
                var matchPattern = /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
                if(value.length > 0) {
                if(!invalidCharacters) {
                    return matchPattern;
                }else {
                    return true;
                }
                }else {
                return true;
                }
            },
            errorMessage: 'Please enter a valid email address.',
            async: false
        }
        var emailInvalidCharacters = {
          comparator: function isValid(value) {
            var matchPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
            var invalidCharacters = /[ `!#$%^&*()\=\[\]{};':"\\|,<>\/?~\+]/.test(value);
            if(value.length > 0) {
              if(invalidCharacters) {
                return matchPattern;
              }else {
                return true;
              }
            }else {
              return true;
            }
          },
          errorMessage: 'Invalid character detected',
          async: false,
        };
        var nameValidation = {
          comparator: function isValid(value) {
            if(value.length > 0) {
              return /^([a-zA-Z0-9 \-\'.ñ]+)$/.test(value);
            }else {
              return true;
            }
          },
          errorMessage: 'Invalid character detected',
          async: false,
        };

        var validatePhone = {
          comparator: function isValid(value) {
            if(value.length > 0) {
              return value.length === 13;
            }else {
              return true;
            }
          },
          errorMessage: 'Mobile number is invalid.',
          async: false,
        };
  
        $form.cfForm.addValidator(validateEmail, 'email');
        $form.cfForm.addValidator(emailInvalidCharacters, 'email');
        $form.cfForm.addValidator(nameValidation, 'first_name');
        $form.cfForm.addValidator(nameValidation, 'last_name');
        $form.cfForm.addValidator(validatePhone, 'phone');
    }

});


const container = document.querySelector('.on-accounts-forms')
const inputs = document.querySelectorAll('input[type="email"]:not([data-cf-input]), input[type="text"]:not([data-cf-input]), input[type="password"]:not([data-cf-input]), input[type="tel"]:not([data-cf-input]), input[type="number"]:not([data-cf-input])');


/*
* Label animation
*/
if(inputs && inputs.length > 0) {
  inputs.forEach(input => {
    input.addEventListener('blur', function() {
      if(this.value.length > 0) {
        this.parentNode.querySelector('.input__animate_label_overlay').classList.add('on-focus');
      }else {
        this.parentNode.querySelector('.input__animate_label_overlay').classList.remove('on-focus');
      }
    })
  })
}

const recover_input_email = document.querySelector('#recover-email');

if(recover_input_email) {
  recover_input_email.addEventListener('keyup', function() {
    const $form = this.closest('form');
    const email = $form.querySelector('input[name="email"]')

    if(email && email.value.length > 0) localStorage.setItem('recover_email', email.value);
  })
}




/*
* Utilities
*/
const upLabel = label => label.classList.add('on-focus');
const downLabel = label => label.classList.remove('on-focus');

const setAttribute = (input, attribute, value) => {
    if(!input) return;
    input.setAttribute(attribute, value);
}

const compileErrorMessage = (message) => {
    const container = document.querySelector('#form_general_error');

    if(!container || !message) return;

    var Shopify = window.Shopify || {};

    let template = Shopify.custom_error_message ?? null;

    if(template) {
        template = template.replace(/{{message}}/g,message);
    }

    return template;

}

const renderErrorMessage = (message) => {
    const container = document.querySelector('#form_general_error');

    if(!container || !message) return;

    container.innerHTML = message;
}